import Bracket from '../../common/Bracket';
import { PREDICTIONS_STEPS_ORDER } from '../../constants';

const ResultsTournamentBracket = () => (
  <Bracket stages={PREDICTIONS_STEPS_ORDER} isResults={true} />
);

export default ResultsTournamentBracket;
